import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { GREAT_WHITE, GYPSUM, OZ_LIGHT } from 'HubStyleTokens/colors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { highestProductLevelFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedColStyles = css(["border-left:1px solid ", ";border-right:1px solid ", ";"], GREAT_WHITE, GREAT_WHITE);
const CurrentPlan = styled.col.withConfig({
  displayName: "FeatureTableCol__CurrentPlan",
  componentId: "sc-102df9a-0"
})(["", " background-color:", ";"], sharedColStyles, GYPSUM);
const RecommendedPlan = styled.col.withConfig({
  displayName: "FeatureTableCol__RecommendedPlan",
  componentId: "sc-102df9a-1"
})(["", " background-color:", ";"], sharedColStyles, OZ_LIGHT);
const FeatureTableCol = ({
  apiName,
  productLine,
  recommendedProductLevel,
  showRecommended = false
}) => {
  const columnProductLevel = getProductLevelFromApiNameString(apiName);
  const isAppAuth = useSelector(isAppAuthSelector);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isCurrentPlan = useSelector(state => hasPricingAndPurchasingSucceeded && highestProductLevelFromProductInventorySelector(state, {
    productLine
  }) === columnProductLevel && isAppAuth);
  if (isCurrentPlan) return /*#__PURE__*/_jsx(CurrentPlan, {});
  if (showRecommended && columnProductLevel === recommendedProductLevel) return /*#__PURE__*/_jsx(RecommendedPlan, {});
  return /*#__PURE__*/_jsx("col", {});
};
export default FeatureTableCol;